/* eslint-disable no-debugger, no-console */
import React, { Component } from 'react';
import { Translate, I18n } from 'react-redux-i18n';
import { connect } from 'react-redux';

import Table from '../components/table/table';
import ModalComponent from '../components/modal';

import { getAdminUsers, toggleAdminUserStatus } from '../app/store/actions/adminUsers';

import { history } from '../routers/AppRouter';
import ROUTES from '../data/routes';

class AdminUsers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      limit: 20,
      page: 1,
      search: '',
      showModal: false,
      modal: {},
      orderBy: 'ASC',
      field: 'id',
    };
  }

  componentDidMount() {
    this.props.searchAdminUsers();
  }

  sortTable = async (field, orderBy) => {
    await this.setState({ orderBy, field });
  }

  updateValues = async (search = '', page = 1) => {
    await this.setState({ search, page });
  }

  Pagination = () => {
    const { adminUsersList } = this.props;
    const { page, search } = this.state;
    const limit = {};
    const adminListOrderedUsers = (adminUsersList || []).sort((first, second) => {
      if(this.state.field === 'id'){
        if(this.state.orderBy === 'ASC'){
          if (first[`${this.state.field}`] > second[`${this.state.field}`]) return 1;  
          if (first[`${this.state.field}`] < second[`${this.state.field}`]) return -1;
        }

        if (this.state.orderBy === 'DESC') {
          if (first[`${this.state.field}`] > second[`${this.state.field}`]) return -1;  
          if (first[`${this.state.field}`] < second[`${this.state.field}`]) return 1;
        }

      }else{
        if(this.state.orderBy === 'ASC'){
          if (first[`${this.state.field}`].toLocaleLowerCase() > second[`${this.state.field}`].toLocaleLowerCase()) return 1;  
          if (first[`${this.state.field}`].toLocaleLowerCase() < second[`${this.state.field}`].toLocaleLowerCase()) return -1;
        }

        if (this.state.orderBy === 'DESC') {
          if (first[`${this.state.field}`].toLocaleLowerCase() > second[`${this.state.field}`].toLocaleLowerCase()) return -1;  
          if (first[`${this.state.field}`].toLocaleLowerCase() < second[`${this.state.field}`].toLocaleLowerCase()) return 1;
        }

      }
    })
    const tableData = (adminListOrderedUsers || []).map((row, index) => ({
      key: index,
      id: row.id,
      name: row.name,
      email: row.email,
      profileName: row.profileName,
      status: (
        <div className="row margin-left-0">
          <button
            type="button"
            className={`btn btn-${row.status === 'active' ? 'warning' : 'dark'} promotion-btn-${
              row.status === 'active' ? 'warning' : 'active'}`}
            onClick={() => this.props.activeUserAdmin(row.id, {
              status: row.status === 'active' ? 'inactive' : 'active',
            })}
          >
            <Translate value={row.status === 'active' ? 'disable' : 'active'} />
          </button>
        </div>
      ),
      action: (
        <div className="row margin-left-0">
          <button
            type="button"
            className="btn btn-dark promotion-btn-active"
            onClick={() => {
              history.push({
                pathname: ROUTES.FORM,
                screenComming: 'admin-users',
                item: row,
              });
            }
              }
          >
            <Translate value="edit" />
          </button>
        </div>
      ),
    }));
    if (search !== '') {
      const tempTableData = tableData.filter(el => {
        return el.name.toLowerCase().includes(search.toLowerCase()) || el.email.toLowerCase().includes(search.toLowerCase()) || el.id.toString().includes(search);
      });
      if (tempTableData.length <= this.state.limit) {
        return {data: tempTableData, count: tempTableData.length };
      } else {
        if (page > 1) {
          limit.limitMax = 20 * page;
          limit.limitMin = (20 * page) - 20;
        }
        else {
          limit.limitMax = 20;
          limit.limitMin = 0;
        }
        return {data: tempTableData.slice(limit.limitMin, limit.limitMax), count: tempTableData.length };
      }
    } else {
      if ((page > 1)) {
        limit.limitMax = 20 * page;
        limit.limitMin = (20 * page) - 20;
      }
      else {
        limit.limitMax = 20;
        limit.limitMin = 0;
      }
      return {data: tableData.slice(limit.limitMin, limit.limitMax), count: tableData.length};
    }
  }

  render() {
    const {
      limit, page, modal, showModal, search
    } = this.state;

    const tableHeader = [
      { key: 'id', value: I18n.t('id') },
      { key: 'name', value: I18n.t('name') },
      { key: 'email', value: I18n.t('email') },
      { key: 'profileName', value: I18n.t('profile') },
      { key: 'status', value: I18n.t('status') },
      { key: 'action', value: I18n.t('action') },
    ];

    const { data = [], count = 0 } = this.Pagination()

    const tableButtons = (
      <React.Fragment>

        <button
          onClick={() => history.push({
            pathname: ROUTES.FORM,
            screenComming: 'admin-users',
          })}
          type="button"
          className="btn btn-dark margin-left-10"
        >
          <Translate value="register" />
        </button>

        <button
          onClick={() => history.push(ROUTES.UPLOAD_ADMINISTRATORS)}
          type="button"
          className="btn btn-secondary margin-left-10"
        >
          <Translate value="import" />
        </button>
      </React.Fragment>
    );

    return (
      <div className="main-div-tables">
        <ModalComponent
          title={modal.title}
          body={modal.body}
          visible={showModal}
          closeModal={() => this.setState({ showModal: false })}
          titleOkButtoon={modal.okBtn}
          size={{ width: '300px', height: '170px' }}
          showButtons
          showCancel={modal.action}
        />

        <Table
          title={I18n.t('adminUsers')}
          header={tableHeader}
          buttons={tableButtons}
          lines={data}
          page={page}
          perPage={limit}
          searchItems={this.updateValues}
          count={count}
          showItemsCount
          sortTable={this.sortTable}
        />
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  searchAdminUsers: () => dispatch(getAdminUsers()),
  activeUserAdmin: (id, { status }) => dispatch(toggleAdminUserStatus(id, status)),
});

const mapStateToProps = state => ({
  adminUsersList: state.adminUsers.adminUsers,
});

export default connect(mapStateToProps, mapDispatchToProps)(AdminUsers);
